<script>
import Vue from "vue";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import CustomerTaskForm from "./forms/customer-tasks-raw-command-form.vue";
import CustomerTaskShow from "../customer-tasks/show/show.vue";
import CustomTable from "../../../components/tables/custom-table.vue";
import AddButton from "../../../components/buttons/add-button.vue";
import api from "../../../helpers/apirest/api";

/**
 * Customers Component
 */
export default {
  components: {
    Layout,
    PageHeader,
    AddButton,
    CustomerTaskForm,
    CustomerTaskShow,
    CustomTable
  },
  data() {
    return {
      formModalId:'customer-tasks-raw-command-form-modal',
      showModalId:'customer-tasks-raw-command-show-modal',
      pageHeader:{
        title: "Customer Tasks - Raw Commands",
        breadcrumbs: [
          {
            text: "Customer Tasks - Raw Commands",
            href: "/customer-tasks-raw-command",
            active: true
          }
        ],
      },
      table:{
        url:'/customer-tasks',
        params: {
          'only_raw_command_task': 1,
        },
        fields:[
          { key: "id", label: "Cod", sortable: true },
          { key: "customer.fullname", label: "Customer", sortable: false },
          { key: "description", label: "Description", sortable: true },
          { key: "target_driver.fullname", label: "Driver", sortable: false },
          { key: "last_sync", label: "Last Successful Execution", sortable: true },
        ]
      },
      formSelectedItemId:null,   
      showSelectedItemId:null,   
    };
  },
  methods: {
    showEditModal(item) {
      this.formSelectedItemId = item?.id || null;
      this.$bvModal.show(this.formModalId);
    },
    showViewModal(item) {
      this.showSelectedItemId = item?.id || null;
      this.$bvModal.show(this.showModalId);
    },
    onSuccess(){
      this.$refs.customerTable.refresh();
    },
    async runTask(customerTask){
      try {

        /*const result = */await Vue.swal({
          title: "Run task now?",
          icon: "info",
          html:  "Are you sure you want to run this task right now?",
          showCloseButton: false,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonText: 'Yes',
          cancelButtonText: 'Cancel',
          showLoaderOnConfirm: true,
          preConfirm: () => {
            return api.save({
                url: `customer-tasks/${customerTask?.id}/run-task`,
                successMsg: 'The synchronization task has been created successfully'
            }).then(()=>{});
          },
        });
        
      }
      catch (error) {
          console.log(error);
      }
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="pageHeader?.title" :items="pageHeader?.breadcrumbs" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <CustomerTaskForm :modal-id="formModalId" :id="formSelectedItemId" @onSuccess="onSuccess"></CustomerTaskForm>
            <CustomerTaskShow :modal-id="showModalId" :id="showSelectedItemId"></CustomerTaskShow>
            <div class="text-right">
              <AddButton @click="showEditModal"></AddButton>
            </div>
            <CustomTable :url="table.url" :fields="table.fields" :params="table.params" @edit="showEditModal" ref="customerTable" :show-view="true" @show="showViewModal" :show-modal-id="showModalId">
              <template v-slot:before-custom-actions="slotProps">
                <a
                    href="javascript:void(0);"
                    class="mr-3 text-primary"
                    v-b-tooltip.hover
                    title="Run task now"
                    @click="runTask(slotProps.row?.item)"
                >
                    <i class="ri-refresh-line font-size-18"></i>
                </a>
              </template>
            </CustomTable>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>